import React from "react";

import Container from 'react-bootstrap/Container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import "./Services.scss";

interface ServiceItem {
    icon: IconProp;
    title: string;
    body: React.ReactNode;
}

const services: ServiceItem[] = [
    {
        icon: "clipboard-check",
        title: "Psychiatric Assessments",
        body: "At Better Days Psychiatry and Family Practice we address virtually every aspect of psychiatric disorders - including depression, bipolar disorder, and a host of other disorders such as anxiety, panic, attention deficit, obsessive compulsive, post- partum depression and post-traumatic stress. We complete full psychiatry evaluations from ages 5 and up.",
    },
    {
        icon: "children",
        title: "Children and Adolescents",
        body: "We are experienced with managing psychiatric care across the lifespan and have several years\u2019 experience managing care of children and adolescents.  We provide medication management for neurodevelopment disorders such as depression, ADHD, PTSD, anxiety and mood disorders. We currently do not do autism evaluations.",
    },
    {
        icon: "stethoscope",
        title: "Family Practice",
        body: "At Better Days Psychiatry and Family Practice we have over eleven years of experience with caring for patients across the life span. We treat patients from birth to geriatric to include multiple chronic conditions and acute illness.  We believe that treating the patient with medical and mental healthcare models helps to strengthen and improve their care holistically.  We do wellness exams, preventative medicine, management of chronic conditions and acute illness.",
    },
    {
        icon: "heart-pulse",
        title: "Telehealth",
        body: "We at Better Days Psychiatry and Family Practice understand that our lives can become very busy, therefore, we strive to improve access to care.  We offer virtual visits for convenience from your home. You need to be able to connect to the internet either via computer, tablet, or phone.  We use a secure and HIPPA compliant platform to complete your visit. Telehealth visits are available to any Missouri resident.",
    },
    {
        icon: "dna",
        title: "Genetic Testing",
        body: (
            <>
                GeneSight is a genetic test that uses DNA gathered from a simple cheek swab to analyze a patient's genes and help provide a personalized approach to prescribing medications. Each patient's genes influence their body's response to specific medications that my not work the same for everyone. The GeneSight report is one piece of information that we use to develop an individualized plan for you. Many government and commercial insurance plans cover Genesight. Insurances such as Medicare, Medicaid and Tricare cover this testing in full. For more information visit{" "}
                <a href="https://genesight.com/">GeneSight</a>.
            </>
        ),
    },
];

export default function Services() {
    return (
        <section className="services-section">
            <Container>
                <header className="services-header">
                    <h2 className="services-title">Services We Offer</h2>
                    <hr className="services-title-divider" />
                </header>

                <div className="services-list">
                    {services.map((service, index) => (
                        <React.Fragment key={service.title}>
                            <div className="services-item">
                                <div className="services-icon">
                                    <FontAwesomeIcon icon={service.icon} />
                                </div>
                                <div className="services-content">
                                    <h3 className="services-item__title">{service.title}</h3>
                                    <p className="services-item__body">{service.body}</p>
                                </div>
                            </div>
                            {index < services.length - 1 && <hr className="services-divider" />}
                        </React.Fragment>
                    ))}
                </div>
            </Container>
        </section>
    );
}
